import { string, object } from 'yup';

export const validationSchema = object().shape({
  title: string().nullable().required('Letter template name is required'),
});
